import { useTranslation } from 'react-i18next';
import { Card, CardContent } from '../components/ui/card';
import { Mail, Phone, MapPin, Building, Zap, Wifi } from 'lucide-react';
import { getSaveaPhone, getSaveaPhoneTel } from '../config/phoneConfig';

export const ContactPage = () => {
  const { i18n } = useTranslation();
  const isSpanish = i18n.language === 'es';
  
  // Numéros selon la langue
  const nrjPhone = isSpanish 
    ? getSaveaPhone('ES', 'electricity', 'LP')
    : getSaveaPhone('FR', 'electricity', 'LP');
  const nrjTel = isSpanish 
    ? getSaveaPhoneTel('ES', 'electricity', 'LP')
    : getSaveaPhoneTel('FR', 'electricity', 'LP');
  const boxPhone = isSpanish 
    ? getSaveaPhone('ES', 'internet', 'LP')
    : getSaveaPhone('FR', 'internet', 'LP');
  const boxTel = isSpanish 
    ? getSaveaPhoneTel('ES', 'internet', 'LP')
    : getSaveaPhoneTel('FR', 'internet', 'LP');

  return (
    <div className="min-h-screen bg-gradient-to-br from-sage-50 to-white">
      <section className="py-16 lg:py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h1 className="text-4xl lg:text-5xl font-bold text-sage-900 mb-4">
              {isSpanish ? 'Contacto' : 'Contact'}
            </h1>
            <p className="text-xl text-sage-600 max-w-3xl mx-auto">
              {isSpanish
                ? 'Nuestro equipo está aquí para ayudarte. Llámanos directamente para cualquier consulta.'
                : 'Notre équipe est là pour vous aider. Appelez-nous directement pour toute question.'
              }
            </p>
          </div>

          {/* Numéros de contact - Énergie & Internet */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
            <a 
              href={`tel:${nrjTel}`}
              className="flex items-center gap-4 bg-gradient-to-r from-amber-500 to-amber-600 text-white rounded-xl p-5 shadow-lg hover:shadow-xl transition-all duration-300"
              data-testid="contact-nrj"
            >
              <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center flex-shrink-0">
                <Zap className="w-6 h-6" />
              </div>
              <div>
                <div className="text-white/80 text-xs font-medium uppercase tracking-wide">
                  {isSpanish ? 'Electricidad' : 'Énergie'}
                </div>
                <div className="font-bold text-lg savea-phone-number">{nrjPhone}</div>
                <div className="text-white/70 text-xs">
                  {isSpanish ? 'Servicio gratuito' : 'Service gratuit'}
                </div>
              </div>
            </a>
            <a 
              href={`tel:${boxTel}`}
              className="flex items-center gap-4 bg-gradient-to-r from-blue-500 to-blue-600 text-white rounded-xl p-5 shadow-lg hover:shadow-xl transition-all duration-300"
              data-testid="contact-box"
            >
              <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center flex-shrink-0">
                <Wifi className="w-6 h-6" />
              </div>
              <div>
                <div className="text-white/80 text-xs font-medium uppercase tracking-wide">Internet</div>
                <div className="font-bold text-lg savea-phone-number">{boxPhone}</div>
                <div className="text-white/70 text-xs">
                  {isSpanish ? 'Servicio gratuito' : 'Service gratuit'}
                </div>
              </div>
            </a>
          </div>

          {/* Horaires */}
          <p className="text-center text-sage-500 text-sm mb-8">
            {isSpanish ? 'Lunes a Sábado • 8h - 21h' : 'Lundi à Samedi • 8h - 21h'}
          </p>

          {/* Info entreprise */}
          <div className="grid md:grid-cols-2 gap-6 mb-6">
            <Card>
              <CardContent className="p-6">
                <div className="flex items-start gap-4">
                  <Building className="w-6 h-6 text-sage-600 mt-1" />
                  <div>
                    <h3 className="font-semibold text-sage-900 mb-2">
                      {isSpanish ? 'Empresa' : 'Société'}
                    </h3>
                    <p className="text-sage-700 text-sm leading-relaxed">
                      SOLUCIONES INTEGRALES HORIZON, S.L.U.<br/>
                      NIF: B23972946
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>

            <Card>
              <CardContent className="p-6">
                <div className="flex items-start gap-4">
                  <MapPin className="w-6 h-6 text-sage-600 mt-1" />
                  <div>
                    <h3 className="font-semibold text-sage-900 mb-2">
                      {isSpanish ? 'Dirección' : 'Adresse'}
                    </h3>
                    <p className="text-sage-700 text-sm leading-relaxed">
                      Calle Radas 57, Ático 1<br/>
                      08004 Barcelona, España
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>

          {/* Email + numéro administratif */}
          <Card>
            <CardContent className="p-6">
              <div className="flex flex-col items-center gap-3">
                <div className="flex items-center gap-3 text-sm text-gray-600">
                  <Mail className="w-4 h-4" />
                  <span>info@savea.info</span>
                </div>
                <div className="flex items-center gap-3 text-sm text-gray-500">
                  <Phone className="w-4 h-4" />
                  <a href="tel:0034930482913" className="hover:text-sage-700 transition-colors">
                    {isSpanish ? 'Administrativo' : 'Administratif'} : +34 930 48 29 13
                  </a>
                </div>
              </div>
            </CardContent>
          </Card>

        </div>
      </section>
    </div>
  );
};
